// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"4f20c73c","306":"21b279a1","328":"bdefbb15","513":"60bc04c6","515":"cb03d97d","564":"24ea833a","585":"62683006","787":"8b1cb1c7"}[chunkId] + ".chunk.js";
};